import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { AppJsonConfigComponent } from '../app-json-config/app-json-config.component';
import { CardView } from 'src/app/interfaces/cardview';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subject, Subscription } from 'rxjs';
import { UploadServices } from 'src/app/services/upload.services';

@Component({
  selector: 'app-config-json',    
  templateUrl: './config-json.component.html',
  styleUrls: ['./config-json.component.scss'],
  standalone: false
})
export class ConfigJsonComponent implements OnInit{


  @ViewChild('datagridCfg') datagridCfg;

  jsonStructure: any;
  mappingConfig: any;
  idUser:any;
  configJson:any;
  rows:any;
  
   
  codecompany:Number; 
  codecontract:Number;
  
  conditionImp:string = '0=1';
  conditionImpLog:string = '0=1';
  conditionCfg:string = '0=1';

  configName: string = "Selecione uma configuração.";
  configHeader: string = "Selecione uma configuração.";
  idRule: string;
  configVisibility:string;
  
  
  eventsSubject: Subject<string> = new Subject<string>();  

  activecompanies:Object;

  parentRow:CardView;

  dparaConfig: any = {};

  sub3:Subscription;

  visibilityOptions = [
  { value: 'O', label: 'Pública' },
  { value: 'C', label: 'Privada' }
  ];

  constructor(public dialog: MatDialog,  private uploadService: UploadServices,
  private _formBuilder:UntypedFormBuilder, private http:HTTPService,public uas:UserAuthenticationServices, private snackServices:SnackbarService,private cdRef: ChangeDetectorRef) {
  
  }

  onTabChanged(event:MatTabChangeEvent){
      this.eventsSubject.next(event.tab.content.templateRef.elementRef.nativeElement.id);
  }

  getConditionFunction = () => this.conditionCfg;

  onJsonLoaded(json: any) {
    this.jsonStructure = json;
  }

  onMappingSaved(mappingConfig: any) {
    this.mappingConfig = mappingConfig;
  }

    
  ngOnInit(): void { 
  
      if  ( this.uas.user.companylist.length > 1 ){ 
        this.codecompany = null;
        this.codecontract = null;
      }else{
        this.codecompany = Number(this.uas.user.companylist[0].codecompany);
        this.codecontract = Number(this.uas.user.companylist[0].codecontract)              
      }
  
      this.idUser = this.uas.user.iduser;

      if(this.codecompany){
        this.conditionCfg = `codecompany=${this.codecompany}`
      }else{
        this.conditionCfg = `1=0`
      }             
  }
  
  getActiveCompanies(){
        let ob = {
          "entityName":"Mktpactivecompanies",
          "sql":`SELECT A.*
                FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
                WHERE A.CODECOMPANY=${this.codecompany}            
                AND A.STATUS=1
                AND A.ENVIRONMENT=1`
        }
    
        let self = this;
         
        this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
             
            if( ObjectUtil.isNotEmpty(con['SQL'])){
              this.activecompanies  = con['SQL'][0];                
              
              this.conditionCfg = `codecompany=${this.codecompany}`;
              
            }else{
              throw Error('Empresa não configurada!');
            }
          });
  }

  selecteRow = (rowsSelect) => {
    this.rows = rowsSelect;  
    

    
    if(this.rows != null && this.rows.length  == 1) {

      this.configName = this.rows[0]['NAME'];
      this.idRule = this.rows[0]['IDRULE'];
      this.configVisibility = this.rows[0]['VISIBILITY'];
      this.configHeader = this.idRule + " - " + this.configName;
      
      this.conditionCfg = `codecompany=${this.codecompany}`;  


      const parsedData = typeof this.rows[0]['RULEJSON'] === 'string' ? JSON.parse(this.rows[0]['RULEJSON']) : this.rows[0]['RULEJSON'];
                   
      this.dparaConfig = parsedData;

    //  this.updateDatagrid(this.datagridCfg); 

    }else{

      this.configName = null;
      this.idRule = null;
      this.configVisibility = null;
      this.configHeader = null;
      this.conditionCfg = `codecompany=${this.codecompany}`;      
    }
        
    //this.updateDatagrid(this.datagridCfg); 
  
  }

  updateDatagrid(): void {
    this.datagridCfg.apply();   
  }

  openDPARAModal(isEdit: boolean): void {
  
      if(this.codecompany == null){
        throw Error('É necessário selecionar uma Empresa para criar/modificar uma configuração!');
      }
  
      let self = this;
         

    const dialogRef = this.dialog.open(AppJsonConfigComponent, {
      width: '100vw',
      height: '80vh',
      maxWidth: '100vw',
      panelClass: 'full-screen-dialog',
      data: {
        idConfig: isEdit ? this.idRule : null,
        dpara: isEdit ? this.dparaConfig : {},
        entity: isEdit ? this.rows?.[0] : null
      }
      
    });
    
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
          
          
          this.dparaConfig = result;
        
                        
          let jsonSave: Object = {      
            entityName: 'Mktpjsonrule',      
            IDUSER: this.idUser,
            CODECOMPANY: this.codecompany,
            VISIBILITY: this.configVisibility,
            NAME: this.dparaConfig.name
          };
          
          if(this.idRule && isEdit ){
            jsonSave['IDRULE'] = this.idRule;
          }

        
          jsonSave['RULEJSON'] =  JSON.stringify(this.dparaConfig);

          
          
        this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe( d=>{

          const idrule = d?.['Mktpjsonrule']?.[0]?.IDRULE || this.idRule;

            // Salva o IDRULE para atualizações futuras
          this.idRule = idrule;


          
          if (result.file) {             
              this.callUploadService(result.file,"Mktpjsonrule","IMGCONFIG",`idrule=${this.idRule}`);  
              this.updateDatagrid();
          }else{
            this.updateDatagrid();
          }
          


            // Faz upload da imagem IMGCONFIG
          this.snackServices.showSuccess('Configurações de Importação salva!')                    
        });
            
        }          
    });
  }


  


  callUploadService(file, entityName:string, columnName:string, condicao:string) {  
      
      const formData = new FormData();  
      formData.append('file', file, 'image');  
      
      let ob = {
          entityName: entityName,
          datafield: columnName,
          condition: condicao
      }
      
      let blob = new Blob([JSON.stringify(ob)], {
        type: 'application/json',
      });

      formData.append('data',JSON.stringify(ob));

      file.inProgress = true;  

      this.sub3 = this.uploadService.progress.subscribe(number=>{
        file.progress = number;
      })

      this.uploadService.upLoadFile(formData).subscribe({
        next: () => {
          this.snackServices.showSuccess('Imagem enviada com sucesso!');
        },
        error: (err) => {
          console.error('Erro ao fazer upload da imagem:', err);
          this.snackServices.showError('Erro ao fazer upload da imagem.');
        }
      });

      
    }

    uploadIMGCONFIG(base64: string, idrule: number) {
      if (!base64 || !idrule) return;

      const byteString = atob(base64);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }

      const imageBlob = new Blob([byteArray], { type: 'image/png' });

      const formData = new FormData();
      formData.append('file', imageBlob, 'imgconfig.png');

      const metadata = {
        entityName: 'Mktpjsonrule',
        datafield: 'IMGCONFIG',
        condition: `IDRULE=${idrule}`
      };

      formData.append('data', JSON.stringify(metadata)); // corrigido: sem Blob

      console.log('Enviando imagem IMGCONFIG para IDRULE=', idrule);
      
      this.uploadService.upLoadFile(formData).subscribe({
      next: (event) => {
        if (event && event.type === 4) {
          // 4 = HttpEventType.Response
          this.snackServices.showSuccess('Imagem da configuração enviada com sucesso!');
        }
      },
      error: (err) => {
        console.error('Erro ao enviar IMGCONFIG:', err);
        this.snackServices.showError('Falha ao enviar imagem da configuração.');
      }
    });
  }

      
    
    
  
}
